import React from 'react';
import SeoHead from '../../components/Menu/components/SeoHead';
import '../../assets/css/politicas.css'; 


const Politicas = () => {

  const politicasVendaSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage", 
  "name": "Políticas de Venda | Waldir Pianos",
  "description": "Conheça as políticas de venda da Waldir Pianos, incluindo informações detalhadas sobre frete (grátis para SP e região metropolitana), opções de pagamento (à vista com desconto, cartão em até 12x) e garantia de 1 ano para todos os pianos vendidos.",
  "url": "https://pianoswaldir.com.br/politicas-de-venda", 
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://pianoswaldir.com.br/politicas-de-venda"
  },
  "isPartOf": {
    "@type": "WebSite",
    "url": "https://pianoswaldir.com.br/",
    "name": "Waldir Pianos"
  },
  "about": { 
    "@type": "Thing", 
    "name": "Políticas de Venda de Pianos"
  },
 
  "hasPart": [
    {
      "@type": "Article",
      "name": "Política de Frete",
      "description": "Detalhes sobre frete grátis para São Paulo e região metropolitana, e cálculo para outras localidades, além de prazos de entrega.",
      "url": "https://pianoswaldir.com.br/politicas-de-venda#frete" // Âncora para a seção
    },
    {
      "@type": "Article",
      "name": "Política de Pagamento",
      "description": "Informações sobre as formas de pagamento aceitas: à vista (transferência/PIX com 5% de desconto) e cartão de crédito (até 12x).",
      "url": "https://pianoswaldir.com.br/politicas-de-venda#pagamento"
    },
    {
      "@type": "Article",
      "name": "Política de Garantia",
      "description": "Regras da garantia de 1 ano para pianos vendidos, cobrindo defeitos de fabricação e problemas estruturais.",
      "url": "https://pianoswaldir.com.br/politicas-de-venda#garantia"
    }
  ]
  
};


  return (
    <div className="container">
<SeoHead
  title="Políticas de Venda Waldir Pianos | Frete, Pagamento e Garantia"
  description="Transparência na compra do seu piano: Conheça as políticas de frete (grátis para SP), opções de pagamento (à vista com desconto, parcelamento) e garantia de 1 ano da Waldir Pianos."
  keywords="políticas de venda piano, frete piano, garantia piano, pagamento piano, Waldir Pianos, termos e condições, compra de pianos, loja de pianos"
  url="https://pianoswaldir.com.br/politicas-de-venda" 
  canonicalUrl="https://pianoswaldir.com.br/politicas-de-venda"
  schemaMarkup={politicasVendaSchema}
/>

      <div className="page-content">
        <h1>Políticas de Venda</h1>
        
        <section className="policy-section">
          <h2>Política de Frete</h2>
          <p>Entrega grátis dentro da cidade de São Paulo SEM ESCADAS. Para demais localidades e subida de escadas, o valor será calculado com base na kilometragem de distância e quantidade de andares respectivamente.  Prazo de entrega: 5 a 15 dias úteis após confirmação do pagamento.</p>
        </section>

        <section className="policy-section">
          <h2>Política de Pagamento</h2>
          <p>Parcelamento no cartão de crédito em até 3x sem juros ou até 12x com acréscimo de taxas à calcular.
</p>
<p>Pagamento à vista via pix com 5% de desconto.</p>
       
        </section>

        <section className="policy-section">
          <h2>Política de Garantia</h2>
          <p>Garantia com assistência técnica de 01 ano na parte técnica dentro da cidade de São Paulo. Demais localidades, não se aplica.</p>
        </section>
      </div>
    </div>
  );
};

export default Politicas;